import { useLayoutEffect } from "react";
import type { TransformerWorklet } from "@-/com.npmjs.react-native-transformer-text-input";
import { registerTextTransformer } from "#persistent-keyboard-module";

/** Install only for the focused route. Cleanup cannot detach a newer route's transformer. */
export function usePersistentKeyboardTextTransformer(
  worklet: TransformerWorklet,
  active: boolean,
): void {
  useLayoutEffect(() => {
    if (!active) {
      return;
    }
    const subscription = registerTextTransformer(worklet);
    return () => subscription.remove();
  }, [active, worklet]);
}
